import { render, staticRenderFns } from "./hiPerson.vue?vue&type=template&id=6275b41c&"
import script from "./hiPerson.vue?vue&type=script&lang=js&"
export * from "./hiPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports